import { BigNumber } from '../components/BigNumber';
import { BreakdownTable } from '../components/BreakdownTable';
import { formatPercent } from '../lib/format';
import type { CalcResult } from '../lib/calculate';

interface ResultStepProps {
  result: CalcResult;
  onRestart: () => void;
}

export function ResultStep({ result, onRestart }: ResultStepProps) {
  const isRefund = result.refundOrOwed >= 0;
  return (
    <div className="space-y-6">
      <BigNumber
        amount={result.refundOrOwed}
        label={isRefund ? 'Estimated refund' : 'Estimated amount owed'}
        sublabel={`Effective rate ${formatPercent(result.effectiveRate)} | Marginal rate ${formatPercent(result.marginalRate)}`}
      />

      <div>
        <h3 className="text-base font-semibold text-slate-900">Breakdown</h3>
        <p className="mt-1 text-sm text-slate-500">
          How we got from your W-2 to this number.
        </p>
        <div className="mt-4">
          <BreakdownTable rows={result.breakdown} />
        </div>
      </div>

      <div className="rounded-xl border border-brand-100 bg-brand-50 p-5 text-sm text-brand-900">
        <p className="font-medium">Want to optimize next year?</p>
        <p className="mt-1 text-brand-800/80">
          Update IRS Form W-4 with your employer. Adding or removing one
          allowance shifts how much is withheld each pay period — and
          therefore whether you get a refund or owe at filing time. The
          IRS Tax Withholding Estimator is the official source.
        </p>
      </div>

      <div className="rounded-xl border border-amber-200 bg-amber-50 p-5 text-xs text-amber-900">
        <p className="font-medium">Disclaimer</p>
        <p className="mt-1 text-amber-800/80">
          Estimate only. Based on 2025 IRS data extrapolated to 2026 with
          ~2.5% inflation. Excludes state tax, capital gains, self-
          employment tax, itemized deductions, and credits. Verify before
          filing; consult a CPA for material decisions.
        </p>
      </div>

      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={onRestart}
          className="rounded-md bg-brand-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-brand-700"
        >
          Start over
        </button>
      </div>
    </div>
  );
}